<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.4023 28L1 23.5429V20.7571M8.4023 28L29 10.1714V7.57143M8.4023 28V24.9667M1 20.7571L8.4023 24.9667M1 20.7571V18.7143L22.5632 2V4.6M8.4023 24.9667L29 7.57143M29 7.57143L22.5632 4.6M22.5632 4.6V6.82857M22.5632 6.82857L5.27778 20.7571M22.5632 6.82857L24.9051 7.94286" stroke="#2D3843" stroke-width="1.25"/>
  </svg>

</template>

<script>
export default {
    name: 'SVGShelfForShelfRight',
};
</script>

<style scoped>

</style>
